import axios from 'axios';

const apiUrl = window._env_?.REACT_APP_API_URL || 'https://app.mylocaleventrentals.com/api';

function getToken() {
  const authTokens = localStorage.getItem('auth_tokens');
  if (authTokens) {
    try {
      const parsed = JSON.parse(authTokens);
      if (parsed?.token) return parsed.token;
    } catch {
      // fallback
    }
  }
  return localStorage.getItem('token');
}

function authHeader() {
  const token = getToken();
  return token ? { 'x-auth-token': token } : {};
}

export const fetchTimesheets = async (params = {}) => {
  const query = new URLSearchParams();
  if (params.start_date) query.set('start_date', params.start_date);
  if (params.end_date) query.set('end_date', params.end_date);
  if (params.status) query.set('status', params.status);
  if (params.user_id) query.set('user_id', params.user_id);

  const url = `${apiUrl}/timesheets${query.toString() ? `?${query.toString()}` : ''}`;
  const res = await axios.get(url, { headers: authHeader() });
  return res.data;
};

export const createTimesheet = async (data) => {
  const res = await axios.post(`${apiUrl}/timesheets`, data, { headers: authHeader() });
  return res.data;
};

export const updateTimesheet = async (id, data) => {
  const res = await axios.put(`${apiUrl}/timesheets/${id}`, data, { headers: authHeader() });
  return res.data;
};

export const deleteTimesheet = async (id) => {
  const res = await axios.delete(`${apiUrl}/timesheets/${id}`, { headers: authHeader() });
  return res.data;
};

export const updateTimesheetStatus = async (id, status) => {
  const res = await axios.patch(`${apiUrl}/timesheets/${id}/status`, { status }, { headers: authHeader() });
  return res.data;
};
